import Component from "../../component";

export const ProductTitleConfig = {
    signature: 'productTitle',
    baseHtmlClass: 'product_title',
    selector: '.product_title',
    initedHtmlClass: 'product_title--inited',
    initedHtmlClassModifier: 'inited',
    separator: ' - ',

    headerSelector: '.product_title__content'
};

export class ProductTitle extends Component {

    static applyToAll() {
        document.querySelectorAll(ProductTitleConfig.selector).forEach((element) => {
            if (!ProductTitle.isElementComponentized(element, ProductTitleConfig.signature)) new ProductTitle(element);
        });
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ProductTitleConfig
        });

        this.headerElement = this.element.querySelector(ProductTitleConfig.headerSelector);

        if (!this.headerElement) return;

        this.originalText = this.headerElement.innerText;

        this.headerElement.innerText = ''; // Clear existing text;

        // Get the title text and subtitle text
        let textPieces = this.originalText.split(ProductTitleConfig.separator);
        this.titleText = textPieces.shift();
        this.subtitleText = textPieces.join(' - ');

        // Insert the title element
        if (this.titleText) {
            this.titleElement = document.createElement('span');
            this.titleElement.classList.add(`${ ProductTitleConfig.baseHtmlClass }__title`);
            this.headerElement.insertBefore(this.titleElement, null);
        }

        // Insert the subtitle element
        if (this.subtitleText) {
            this.subtitleElement = document.createElement('span');
            this.subtitleElement.classList.add(`${ ProductTitleConfig.baseHtmlClass }__subtitle`);
            this.headerElement.insertBefore(this.subtitleElement, null);
        }

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, ProductTitleConfig.initedHtmlClassModifier);
        if (this.titleElement) this.titleElement.textContent = this.titleText;
        if (this.subtitleElement) this.subtitleElement.textContent = this.subtitleText;
    }

}
